
export function getUserDetailsUsingDsrMembersArray(dsrTeamMembers, providedUserId) {
  if (!dsrTeamMembers) return null

  const sellerTeamArray = dsrTeamMembers["sellerTeam"] ? dsrTeamMembers["sellerTeam"] : []
  const buyerTeamArray = dsrTeamMembers["buyerTeam"] ? dsrTeamMembers["buyerTeam"] : []
  const combinedDsrTeamMembersArray = [...sellerTeamArray, ...buyerTeamArray]

  if (combinedDsrTeamMembersArray && providedUserId) {
    for (const organization of combinedDsrTeamMembersArray) {
      const {orgTeamMembers} = organization || {};

      for (const memberProfile of orgTeamMembers) {
        if (memberProfile.userId === providedUserId) {
          return memberProfile
        }
      }  
    }   
  }

   // Defaults to return empty profile if nothing was found
   return null;
}

export function getFullName(userPersonalProfile) {
  const {firstName, lastName} = userPersonalProfile || {};
  if (!firstName && !lastName) {
    return ""
  } else if (firstName && !lastName) {
    return firstName
  } else if (!firstName && lastName){
    return lastName
  } else {
    return firstName + ' ' + lastName
  }
}

// This function is used to automatically retrieve first & last names based on user's entry into a single name input
export function splitNameInput(str) {
  const words = str.trim().split(/\s+/);
  if (words.length === 1) {
    return { firstName: words[0].trim(), lastName: "" };
  } else {
    return { firstName: words[0].trim(), lastName: words.slice(1).join(" ").trim() };
  }
};

export function getUserAccountType() {
  const userCategory = localStorage.getItem('USER_CATG');

  return userCategory;
}

export function determineIsNonCustomerUserAccount() {
  const userCategory = localStorage.getItem('USER_CATG');

  if (userCategory==="no-org-user" || userCategory==="no-category-user") {
    return true
  } else return false
}

export function combineAllMembersArray(dsrTeamMembers) {
  const { sellerTeam, buyerTeam } = dsrTeamMembers || {};

  if (sellerTeam) {
    const allMembersArray = (sellerTeam && buyerTeam) ? [...sellerTeam, ...buyerTeam] : [...sellerTeam]
    return allMembersArray
  } else return null;
}

export function sortArrayToListActiveMembersFirst(orgTeamMembers) {
  if (!Array.isArray(orgTeamMembers)) return [];

  const activeMembers = orgTeamMembers.filter(member => member.memberStatus === 'active');
  const nonActiveMembers = orgTeamMembers.filter(
    member => !['active', 'removed'].includes(member.memberStatus)
  );

  if (nonActiveMembers.length > 1) {
    return nonActiveMembers.slice().sort((a, b) => {
      const order = { pending: 0, invited: 1 };
      return order[a.memberStatus] - order[b.memberStatus];
    });
  }

  return {activeMembersList: activeMembers, nonActiveMembersList: nonActiveMembers}
}

export function combineDsrActiveTeamMembersFromAllOrgs(enrichedDsrTeamMembersObj) {
  let combinedMembersArray = []
  if (enrichedDsrTeamMembersObj) {
    for (const org of enrichedDsrTeamMembersObj) {
      const {orgTeamMembers} = org || {}
      if (orgTeamMembers) {
        orgTeamMembers?.forEach(member => {
          if (member.memberStatus === "active" && member.userStatus==="active") {
            combinedMembersArray.push(member);
          }
        });
      }
    }
  }

  return combinedMembersArray
}

export function combineAllDsrTeamMembersFromAllOrgs(dsrTeamMembers) {

  let combinedMembersArray = []
  const combinedArray = combineAllMembersArray(dsrTeamMembers)

  if (combinedArray) {
    for (const org of combinedArray) {
      const {orgTeamMembers} = org || {}

      if (orgTeamMembers) {
        orgTeamMembers?.forEach(member => {
          if ((member.memberStatus === "active" || member.memberStatus === "pending" || member.memberStatus === "invited") && member.userStatus==="active") {
            combinedMembersArray.push(member);
          }
        });
      }
    }
  }

  return combinedMembersArray
}
